import { makeSupabaseEdgeHttpClient } from '@/main/factories/http'
import { extractVideoPosterFrame, uploadToSignedUrl } from '@/shared/infra/files'
import { SupabaseUploadGalleryVideoRepository } from '@/modules/gallery/infra'
import type { UploadGalleryVideo } from '@/modules/gallery/use-cases'

export function makeUploadGalleryVideo(): UploadGalleryVideo {
  return new SupabaseUploadGalleryVideoRepository(
    makeSupabaseEdgeHttpClient(),
    uploadToSignedUrl,
    extractVideoPosterFrame,
  ).execute
}
